import '.a5{position:fixed;}.ssr-plugin'
import '.c3{top:0;}.ssr-plugin'
import '.bi{left:0px;}.ssr-plugin'
import '.bj{right:0px;}.ssr-plugin'
import '.f1{bottom:0px;}.ssr-plugin'
import '.hc{background-color:rgba(0, 0, 0, 0.25);}.ssr-plugin'
import '.hd{z-index:998;}.ssr-plugin'
import '.he{transition:opacity 0.3s ease;}.ssr-plugin'
import '.q{height:100vh;}.ssr-plugin'
import '.a8{width:100%;}.ssr-plugin'
import '.as{background-color:var(--shades-white);}.ssr-plugin'
import '.hf{transition:transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);}.ssr-plugin'
import '.hg{z-index:999;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.a9{justify-content:space-between;}.ssr-plugin'
import '.cc{padding:1.5rem;}.ssr-plugin'
import '.hh{border-bottom:1px solid var(--gray-border);}.ssr-plugin'
import '.bp{flex-shrink:0;}.ssr-plugin'
import '.bt{flex:1;}.ssr-plugin'
import '.at{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { IconButton } from '@app/components/core/button/IconButton'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { PropsWithChildren } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'

export interface DrawerProps extends PropsWithChildren {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  portal?: HTMLElement
  style?: Style
  side: 'left' | 'right'
}

export const Drawer = ({
  title,
  open,
  setOpen,
  children,
  portal: _portal,
  style,
  side,
}: DrawerProps) => {
  const isMobile = useMediaQuery()

  const translateValue = open ? '0' : side === 'left' ? '-100%' : '100%'

  return (
    <>
      {/* Overlay */}
      <div className="a5 c3 bi bj f1 hc hd he"
        onClick={() => setOpen(false)}
        style={{
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',}}
      />

      {/* Sidebar Panel */}
      <styled.div className="a5 c3 q a8 as hf hg a b"
        style={{
          [side]: 0,
          maxWidth: isMobile ? '100%' : '30rem',
          borderRadius: isMobile ? 0 : '1.25rem',
          boxShadow: open ? '0 0 15px rgba(0,0,0,0.15)' : 'none',
          transform: `translateX(${translateValue})`,
          ...style,
        }}
      >
        {/* Header */}
        <div className="a c a9 cc hh bp"
        >
          <Title.H4 style={{ margin: 0 }}>{title}</Title.H4>
          <IconButton
            icon={faXmark}
            size="small"
            variant="secondary"
            onClick={() => setOpen(false)}
          />
        </div>

        {/* Content */}
        <div className="bt at cc"
        >
          {children}
        </div>
      </styled.div>
    </>
  )
}
